export default __webpack_public_path__ + "static/media/payment.ca1518b5.png";